export class FilterEngine {
  static filter(entity: Record<any, any>[], filters: FilterCriteria[]) {
    return entity.filter(entity => {
      return filters.every(filter => filter.matches(entity))
    })
  }
}
